import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "list", "option"]

  connect() {
    this.isOpen = false
    this.selectedIndex = -1
    this._setInitialValue()
    this._handleOutsideClick = this._handleOutsideClick.bind(this)
    document.addEventListener("click", this._handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this._handleOutsideClick)
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    let visibleCount = 0

    if (this.hiddenTarget.value && this.inputTarget.value !== this.hiddenTarget.value) {
      this.hiddenTarget.value = ""
    }

    this.optionTargets.forEach((option) => {
      const text = option.textContent.toLowerCase()
      const visible = text.includes(query)
      option.style.display = visible ? "" : "none"
      if (visible) visibleCount++
    })

    this.selectedIndex = -1
    if (!this.isOpen && query.length > 0) this._open()
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.hiddenTarget.value = value
    this._close()
  }

  onFocus() {
    this.filter()
    this._open()
  }

  onKeydown(event) {
    if (!this.isOpen) {
      if (event.key === "ArrowDown" || event.key === "Enter") {
        this._open()
        event.preventDefault()
      }
      return
    }

    const visibleOptions = this.optionTargets.filter(
      (o) => o.style.display !== "none"
    )

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.selectedIndex = Math.min(
          this.selectedIndex + 1,
          visibleOptions.length - 1
        )
        this._highlightOption(visibleOptions)
        break
      case "ArrowUp":
        event.preventDefault()
        this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
        this._highlightOption(visibleOptions)
        break
      case "Enter":
        event.preventDefault()
        if (this.selectedIndex >= 0 && visibleOptions[this.selectedIndex]) {
          visibleOptions[this.selectedIndex].click()
        }
        break
      case "Escape":
        this._close()
        break
    }
  }

  _setInitialValue() {
    const currentValue = this.hiddenTarget.value
    if (currentValue) {
      this.inputTarget.value = currentValue
    }
  }

  _open() {
    this.isOpen = true
    this.listTarget.style.display = "block"
    this.inputTarget.setAttribute("aria-expanded", "true")
  }

  _close() {
    this.isOpen = false
    this.listTarget.style.display = "none"
    this.inputTarget.setAttribute("aria-expanded", "false")
    this.selectedIndex = -1
    this._clearHighlight()
  }

  _highlightOption(visibleOptions) {
    this._clearHighlight()
    if (this.selectedIndex >= 0 && visibleOptions[this.selectedIndex]) {
      visibleOptions[this.selectedIndex].classList.add(
        "searchable-select-highlighted"
      )
      visibleOptions[this.selectedIndex].scrollIntoView({ block: "nearest" })
    }
  }

  _clearHighlight() {
    this.optionTargets.forEach((o) =>
      o.classList.remove("searchable-select-highlighted")
    )
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this._close()
    }
  }
}
